// export const BASE_URL = "https://bhavsarapi.tp-team.com/api/v1/";
// export const BASE_URL = "https://bhawsaruat.tpots.in/api/v1/";
export const BASE_URL = "https://stageapi.bhawsarayurveda.in/api/v1/";
// export const BASE_URL = "https://api.bhawsarayurveda.in/api/v1/";
export const TOKEN_TYPE = "Bearer ";
export const REQUEST_HEADER_AUTH_KEY = "Authorization";
